module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0007#ch01"
    }
  }, [_vm._v("Chapter 1   How Can a Myth Be Modern?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0008#ch02"
    }
  }, [_vm._v("Chapter 2   John Bull on a Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Robinson Crusoe")]), _vm._v(" (1719)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0009#ch03"
    }
  }, [_vm._v("Chapter 3   The Reanimator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Frankenstein")]), _vm._v(" (1818)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0010#ch04"
    }
  }, [_vm._v("Chapter 4   Unchaining the Beast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The Strange Case of Dr. Jekyll and Mr. Hyde")]), _vm._v(" (1886)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0011#ch05"
    }
  }, [_vm._v("Chapter 5   The Body and the Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("Dracula")]), _vm._v(" (1897)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0012#ch06"
    }
  }, [_vm._v("Chapter 6   Who Shall Dwell in these Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('i', [_vm._v("The War of the Worlds")]), _vm._v(" (1897)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0013#ch07"
    }
  }, [_vm._v("Chapter 7   Reason Wears a Deerstalker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("The Sherlock Holmes stories (1887–1927)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0014#ch08"
    }
  }, [_vm._v("Chapter 8   I Am the Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Batman (1939–)")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0015#ch09"
    }
  }, [_vm._v("Chapter 9   Myths in the Making, Myths to Come")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0016#ch10"
    }
  }, [_vm._v("Chapter 10   The Mythic Mode")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0017#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0018#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0019#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0020#index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiball0021#fn_notes"
    }
  }, [_vm._v("Footnotes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49027cb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-ball-0006.vue
// module id = 69
// module chunks = 0